import type { IHeroBanner } from '~/components/widget/hero-banner'
import type { ICryptoCompanyServiceName } from '~/components/entity/crypto-company/item/types'

export const heroBanner: IHeroBanner = {
  heading: 'Обмен криптовалют в Кыргызстане',
  text: 'Список обменых бюро криптовалют Кыргызстана с возможностью поиска, адресами отделений и банкоматов, отзывами клиентов, подробными сведениями об услугах и продуктах.',
  image: '/images/photostock/banner-image-running-bank-card-270x184.avif'
}

export const cryptoCompanyServices: ICryptoCompanyServiceName[] = [
  { name: 'office', text: 'entity.crypto_company.services.office' },
  { name: 'remote', text: 'entity.crypto_company.services.remote' },
  { name: 'transfer', text: 'entity.crypto_company.services.transfer' },
  { name: 'accounting', text: 'entity.crypto_company.services.accounting' },
  { name: 'cards_supported', text: 'entity.crypto_company.services.cards_supported' },
  { name: 'autos_support', text: 'entity.crypto_company.services.autos_support' },
  { name: 'realestate_support', text: 'entity.crypto_company.services.realestate_support' },
  { name: 'kyc', text: 'entity.crypto_company.services.kyc' },
  { name: 'allday_support', text: 'entity.crypto_company.services.allday_support' },
  { name: 'allday', text: 'entity.crypto_company.services.allday' }
]

export default {
  heroBanner
}
